export default __webpack_public_path__ + "comprehensive6826f1.png";